import { FC } from 'react';
import { Dialog } from 'primereact/dialog';
import { useQuery } from '@tanstack/react-query';
import { formatDate } from '@/utils/formatDate';
import { TableData } from '@/components/Table/types';
import { Table, LoadingSpinner } from '@/components';
import { ColumnProps } from 'primereact/column';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook } from '@fortawesome/free-solid-svg-icons';
import { getScheduleImportFcl } from '../Depo20/services/getScheduleImportFcl';

type ModalProps = {
  setVisibility: (visibility: boolean) => void;
  visible: boolean;
};

const ScheduleModalImportFCL: FC<ModalProps> = ({ setVisibility, visible }) => {
  const { t } = useTranslation('importFCL');

  const { data = [], isFetching } = useQuery({
    queryKey: ['schedule'],
    queryFn: () => getScheduleImportFcl(),
  });

  const toggleDialog = () => {
    setVisibility(!visible);
  };

  const dialogHeader = (
    <div className="text-blue-800">
      <FontAwesomeIcon icon={faBook} style={{ marginRight: '0.5rem' }} />
      {t('scheduleDetail')}
    </div>
  );

  const columns: ColumnProps[] = [
    {
      field: 'fecha',
      header: t('scheduleTable.date'),
      body: (rowData) => formatDate(rowData?.fecha),
    },
    {
      field: 'disponibles',
      header: t('scheduleTable.availables'),
    },
  ];

  return (
    <Dialog
      header={dialogHeader}
      visible={visible}
      style={{
        maxWidth: window.innerWidth <= 1200 ? '95vw' : '1200px',
        minWidth: window.innerWidth <= 1200 ? '95vw' : '1200px',
      }}
      onHide={toggleDialog}
      modal
    >
      <div className="pb-4 px-4">
        <p>{t('scheduleAvailableMessage')}</p>
        <br />
        {isFetching ? (
          <LoadingSpinner />
        ) : (
          <Table columns={columns} data={data as unknown as TableData} />
        )}
      </div>
    </Dialog>
  );
};

export default ScheduleModalImportFCL;
